import { useGetContext } from "@onefront/forrestjs-react-root";
import { useQueryString } from "../../utils/use-query-string";

import { useOneFrontStore } from "../store/onefront-store";
import { useShallow } from "zustand/react/shallow";

const ZustandStateGate = () => {
  const { getItem, removeItem } = useQueryString();
  const urlKey = useGetContext("one.axios.sessions.param.key");

  const { loading, loadFromQueryString } = useOneFrontStore(
    useShallow((state) => ({
      loading: state.loading,
      loadFromQueryString: state.loadFromQueryString
    }))
  );

  if (!loading) {
    return null;
  }

  const encodedSession = getItem(urlKey);

  if (encodedSession) {
    removeItem(urlKey);
    try {
      const session = JSON.parse(atob(encodedSession));

      loadFromQueryString(session);
    } catch (e) {
      console.error("Error parsing session from query string", e);
    }
  } else {
    loadFromQueryString();
  }

  return null;
};

export { ZustandStateGate };
